export enum Filter {
  SEX = 'sex',
  QUERY = 'query',
  CENTURIES = 'centuries',
}
